export default function HtmlStringEmbed({ name, content }) {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: content,
      }}
      aria-label={`${name}`}
    />
  );
}
